<template>
  <ok-cancel-close-modal
    v-if="showAcceptModal"
    :okButton="$t('commons.save')"
    :cancelButton="$t('explorer.reset')"
    v-on:ok="onOk"
    v-on:cancel="onCancel"
    v-on:close="onClose"
    :title="$t('explorer.correlationOptions.fixedAxes')">
    <div slot="body">
      {{ $t('explorer.axisX') }}
      <div class="range-form">
        <label-input
          :label="$t('explorer.min')"
          v-model="range.x[0]"
          type="number"
          class="range-input-left"
          :errorMessage="$t('explorer.rangeErrorMin')"
          :error="errorX"/>
        <label-input
          :label="$t('explorer.max')"
          v-model="range.x[1]"
          type="number"
          class="range-input-right"
          :errorMessage="$t('explorer.rangeErrorMax')"
          :error="errorX"/>
      </div>
      {{ $t('explorer.axisY') }}
      <div class="range-form">
        <label-input
          :label="$t('explorer.min')"
          v-model="range.y[0]"
          type="number"
          class="range-input-left"
          :errorMessage="$t('explorer.rangeErrorMin')"
          :error="errorY"/>
        <label-input
          :label="$t('explorer.max')"
          v-model="range.y[1]"
          type="number"
          class="range-input-right"
          :errorMessage="$t('explorer.rangeErrorMax')"
          :error="errorY"/>
      </div>
      <span
        v-if="this.hasIntensity">
        {{ $t('explorer.intensity') }}
        <div class="range-form">
          <label-input
            :label="$t('explorer.min')"
            v-model="zRange[0]"
            type="number"
            class="range-input-left"
            :errorMessage="$t('explorer.rangeErrorMin')"
            :error="errorZ"/>
          <label-input
            :label="$t('explorer.max')"
            v-model="zRange[1]"
            type="number"
            class="range-input-right"
            :errorMessage="$t('explorer.rangeErrorMax')"
            :error="errorZ"/>
        </div>
      </span>
    </div>
  </ok-cancel-close-modal>
</template>

<script>
import OkCancelCloseModal from '@/components/shared/dialogs/OkCancelCloseModal';
import LabelInput from '@/components/shared/forms/LabelInput';

export default {
  components: {
    OkCancelCloseModal,
    LabelInput
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    x: {
      type: Number,
      default: null
    },
    y: {
      type: Number,
      default: null
    },
    z: {
      type: Number,
      default: null
    },
    hasIntensity: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showAcceptModal: false,
      range: { x: [], y: [] },
      zRange: [],
      errorX: false,
      errorY: false,
      errorZ: false,
      max: Math.max(),
      min: Math.min(),
      userSaveRange: false
    };
  },
  watch: {
    data: {
      handler () {
        const variables = this.data.variables;
        if (this.range.x.length === 0 && this.range.y.length === 0 && !this.userSaveRange) {
          this.setMaxMinFrom(variables);
        }
      },
      deep: true
    }
  },
  methods: {
    setMaxMinFrom (variables) {
      if (variables && this.x && this.y) {
        const xData = variables.find(variable => variable.metadata.id === this.x).data.map(dataInfo => dataInfo.value);
        const yData = variables.find(variable => variable.metadata.id === this.y).data.map(dataInfo => dataInfo.value);
        this.range = {
          x: [String(Math.min(...xData)), String(Math.max(...xData))],
          y: [String(Math.min(...yData)), String(Math.max(...yData))]
        };
        if (this.z) {
          const zData = variables.find(variable => variable.metadata.id === this.z).data.map(dataInfo => dataInfo.value);
          this.zRange = [String(Math.min(...zData)), String(Math.max(...zData))];
        }
      }
    },
    show () {
      this.errorX = false;
      this.errorY = false;
      this.errorZ = false;
      this.showAcceptModal = true;
    },
    setRange (range, zRange) {
      if (range && range.x.length === 2 && range.y.length === 2) {
        this.range = range;
        this.userSaveRange = true;
      }
      if (zRange && zRange.length === 2) {
        this.zRange = zRange;
        this.userSaveRange = true;
      }
    },
    onOk () {
      this.errorX = !this.range.x[0] || !this.range.x[1] || Number(this.range.x[0]) >= Number(this.range.x[1]);
      this.errorY = !this.range.y[0] || !this.range.y[1] || Number(this.range.y[0]) >= Number(this.range.y[1]);
      this.errorZ = this.z !== null ? Number(this.zRange[0]) >= Number(this.zRange[1]) : false;

      if (!this.errorX && !this.errorY && !this.errorZ) {
        this.showAcceptModal = false;
        this.emitSetChange();
      }
    },
    onCancel () {
      this.showAcceptModal = false;
      this.emitUnsetChange();
    },
    onClose () {
      this.showAcceptModal = false;
      if (this.errorX || this.errorY || this.errorZ) {
        this.emitUnsetChange();
      }
    },
    emitSetChange () {
      this.userSaveRange = true;
      this.$emit('change', { x: this.range.x.slice(), y: this.range.y.slice(), z: this.zRange.slice() });
    },
    emitUnsetChange () {
      this.userSaveRange = false;
      this.setMaxMinFrom(this.data.variables);
      this.$emit('change', { x: this.range.x.slice(), y: this.range.y.slice(), z: this.zRange.slice() });
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../../stylesheets/variables.scss";

  .range-form {
    display: flex;
  }

  .range-input-left {
    width: 50%;
    margin-right: $sp-margin-small;
  }

  .range-input-right {
    width: 50%;
    margin-left: $sp-margin-small;
  }
</style>



// WEBPACK FOOTER //
// src/components/explorer/correlation/FixedRangeModal.vue